import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { OrderWizardService } from "../../../_service/order-wizard.service";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'order-wizard-save-and-pay',
    imports: [TranslateModule],
    templateUrl: './order-wizard-save-and-pay.component.html',
    styleUrls: ['./order-wizard-save-and-pay.component.scss'],
})
export class OrderWizardSaveAndPayComponent implements OnInit {
    form: FormGroup | null = null;

    constructor(
        public _orderWizardService: OrderWizardService,
    ) {
        this.form = this._orderWizardService.formGroup;
    }
    
    ngOnInit(): void {
        this._orderWizardService.initiatePayment();

    }

    public save() {
        this._orderWizardService.save(this.form?.getRawValue()); 
    }
}